/** 账号记录 */
export const AccountListFields = {
    /* 记录流水号 */
    recordNo: 'id',
    /* 关联单号 */
    relationNo: 'extraBiz',
    /* 收支类型 */
    incomeOutType: 'loanType',
    incomeOutTypeDesc: 'loanTypeName',
    /* 变动来源 */
    changeSource: 'appChangeType',
    changeSourceDesc: 'appChangeValue',
    /* 变动金额 */
    changeAmount: 'changeBalance',
    /* 服务费余额 */
    serviceBalance: 'remainBalance',
    /* 备注 */
    remark: 'remark',
    /* 变动时间 */
    changeTime: 'gmtCreate',
};

/** Tab类型 */
export const RoleType = {
    /** 用户 */
    USER: 'USER'
};